import { EventService, IEventPayload } from '@/app/services/event'
import { ErrorResponse, IApiIndividualResponse } from '@/types/api'
import { IEvent } from '@/types/event'

import { useMutation } from 'react-query'

export function useEventMutation() {
  return useMutation<IApiIndividualResponse<IEvent>, ErrorResponse, IEventPayload>(
    EventService.POST_PATH,
    EventService.postEvent
  )
}
